import { Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  constructor(private http: HttpClient) {}
  /**
   * encontrar vehiculo por placa
   */
  findVehicle(data:any, type:any): Observable<any>{
    const body = JSON.stringify({data:data,type:type});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/findvehicle`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * Guardar formulario de vehiculo
   */
  addVehicle(data: any): Observable<any>{
    const body = JSON.stringify({form:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    //const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/add`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * encontrar vehiculo por placa
   */
  findProcedure(data:any): Observable<any>{
    const body = JSON.stringify({data:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/findprocedure`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * Guardar tramites
   */
  addVehicleProcedure(data:any): Observable<any>{
    const body = JSON.stringify({form:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/addvehicleprocedure`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * encontrar leasing
   */
  findLeasing(data:any): Observable<any>{
    const body = JSON.stringify({data:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/findleasing`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * Guardar leasing
   */
  addVehicleLeasing(data:any): Observable<any>{
    const body = JSON.stringify({form:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/addleasing`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Guardar confirmar vehiculo
   */
  addVehicleConfirmation(data:any): Observable<any>{
    const body = JSON.stringify({form:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/vehicle/confirmationvehicle`,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }
  /**
   * Guardar categoria vehiculo
   */
  actionsVehicleCategory(data:any,met:any): Observable<any> {
    const body = JSON.stringify({data:data});
    const headers = new HttpHeaders()
        .set('X-Api-Key', `${API_KEY}`)
        .set('Content-Type', 'application/json');
    this.controlLoader(true);
    return this.http.post<any>(
        `${END_POINT}/categoryvehicle/`+met,
        body,
        { headers }
    ).pipe(
        tap(() => {
          this.controlLoader(false);
        })
    );
  }

  /**
   * Función para mostrar o remover loading
   */
  controlLoader(show:boolean):void{
    // let elemet: any = document.getElementsByClassName("loader-screen")[0];
    // elemet.style.opacity = 0.8;
    // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
  }


}
